import {
  ArticlesIndexPageOrArticlePage,
  getStaticPropsForArticleIndexPageOrArticlePage,
  getStaticPathsForArticleIndexPagesAndArticlePages,
} from '@marketing-sites/blog-components/components/ArticlesIndexPageOrArticlePage'

export const getStaticProps = getStaticPropsForArticleIndexPageOrArticlePage
export const getStaticPaths = getStaticPathsForArticleIndexPagesAndArticlePages

export default ArticlesIndexPageOrArticlePage
